import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { Card } from 'syf-component-library/ui/atoms/Card';
import Button from 'syf-component-library/ui/atoms/Button';
import redirectToAuth from '../../../helpers/redirectToAuth';
import Callback from '../Callback';
import getLoginHint from './getLoginHint';
import { accessTokenStorageKey, apigeeClientIdMap, authDomain } from './config';
const CardContent = styled.div `
  padding: 20px;
`;
/**
 * This component is designed for internal QA/UAT use only. Will allow you to login with the shared MFE apigee app for testing purposes.
 *
 * @param region host region to authenticate with 'QA' | 'UAT'
 * @param clientId client type to authenticate with 'lowes'
 * @param onSuccess callback when authentication is complete
 * @param onError callback when authentication fails
 * @returns
 */
export const Login = ({ region, clientId, loginType, prompt, onSuccess, onError }) => {
    const accessToken = window.sessionStorage.getItem(accessTokenStorageKey);
    const redirectUri = `${window.location.origin}${window.location.pathname}`;
    const loginHintUrl = getLoginHint(clientId, loginType, region, prompt);
    const hasCode = !!new URL(window.location.href).searchParams.get('code');
    const apigeeClientId = apigeeClientIdMap[loginType];
    const authenticateCallback = () => {
        redirectToAuth({
            baseURL: authDomain[region],
            clientId: apigeeClientId,
            redirectURI: redirectUri,
            loginHintURL: loginHintUrl,
            prompt
        });
    };
    const logout = () => {
        window.sessionStorage.removeItem(accessTokenStorageKey);
    };
    if (accessToken) {
        return (_jsx(Button, { onClick: () => logout(), buttonType: "primary", children: "Logout" }));
    }
    return (_jsx(Card, { title: `${region} Login With ${clientId}`, children: _jsxs(CardContent, { children: [_jsx(Button, { onClick: authenticateCallback, buttonType: "primary", children: "Begin Login" }), hasCode && (_jsx(Callback, { apiHost: authDomain[region], apigeeClientId: apigeeClientId, redirectUri: redirectUri, authorizedCallback: onSuccess, successCallback: onSuccess, errorCallback: onError }))] }) }));
};
export default Login;
